// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wpnN2","carousel":"styles_carousel__zQKoC"};